import React from 'react';

import { ChildrenProps } from '../../../../../utils';
import { ClassNameDecorator } from '../../../../decorators';
import { ClassInjector } from '../../../../injectors';

import './AsLink.scoped.scss';

const AsLink: ClassNameDecorator<ChildrenProps> = ({ children, className }) => {
  return (
    <ClassInjector classNames={'link-button'} oldClassName={className}>
      {children}
    </ClassInjector>
  );
};

export default AsLink;
